import './Options.css';
const Options = (props) => {
  const options = [
    {
      id: 1,
      text: '🖖 Solo pasaba a saludar',
      handler: props.actionProvider.handleGreet,
    },
    {
      id: 2,
      text: '💻 Quisiera contratarte',
      handler: props.actionProvider.handleContact,
    },
    {
      id: 3,
      text: '😄 compartir la página',
      handler: props.actionProvider.handleShare,
    },
  ];

  const buttonOptions = (
    <div className="Options">
      {options.map((option) => (
        <button
          className="Options__button"
          key={option.id}
          onClick={option.handler}
        >
          {option.text}
        </button>
      ))}
    </div>
  );

  return buttonOptions;
};

export default Options;
